import React, { useContext, useRef, useEffect } from "react";
import { Icon } from "@iconify/react";

import { useLanguageVisibility } from "../../../../language/hooks/use-language-visibility";
import { store } from "../../../../Store";
import { DropdownLang } from "../../../../language/dropdown-lang";
import { useLanguage } from "../../../../../hooks/use-language";
import { useTranslationsById } from "../../../../../hooks/use-translations-by-id";
import { useLanguageSelection } from "../../../../../hooks/use-language-selection";

/**
 * Rederiza el boton de lenguaje en el Header
 * @returns {React.Component}
 */
export const QuickLangButton = ({ cerrarVentana }) => {
    const languageVisibility = useLanguageVisibility();
    const globalState = useContext(store);
    const isAuth = globalState?.state?.sesionActiva === "SI";
    const language = useLanguage();
    const languageSelection = useLanguageSelection();
    const texts = useTranslationsById({ mainSectionName: "header", language: language });

    const langRef2 = useRef(null);

    
    const updateLanguage = (lang) => {
        languageSelection.setLanguage({lang});
        localStorage.setItem('language', lang);
        if (languageVisibility.isVisible) {
            globalState.dispatch({
                type: "CHANGE",
                path: "languageDropdown.visible",
                value: false,
            });
        }
    }

    const handleVisibility = () => {

        if(language === "es"){
            updateLanguage('en')
        }else{
            updateLanguage('es')
        }
        if (cerrarVentana) {
            cerrarVentana();
        }
    }
    return (
        <div ref={langRef2}>
            <button
                className={`focusable-red button-lang`}
                onClick={() => { handleVisibility(); }}
                aria-label={texts?.getText({ id: "button_languages_description", defaultText: "Abrir la lista desplegable de idiomas seleccionables" })}
            >
                <Icon icon="tabler:language" width={25} height={25} className="ml-0" />

                {language === "es" ? 'Español' : 'English'}
            </button>

        </div>

    )
}